// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__317iK","grid":"Footer_grid__VYHH5","copyright":"Footer_copyright__YRIln","social_media":"Footer_social_media__TQyva"};